/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type UserSubGroupWhereInput = {
    readonly AND?: ReadonlyArray<UserSubGroupWhereInput> | null;
    readonly created?: any | null;
    readonly created_btwn?: ReadonlyArray<any> | null;
    readonly created_gt?: any | null;
    readonly created_gte?: any | null;
    readonly created_in?: ReadonlyArray<any> | null;
    readonly created_lt?: any | null;
    readonly created_lte?: any | null;
    readonly created_nbtwn?: ReadonlyArray<any> | null;
    readonly created_nin?: ReadonlyArray<any> | null;
    readonly creator?: string | null;
    readonly creator_btwn?: ReadonlyArray<string> | null;
    readonly creator_gt?: string | null;
    readonly creator_gte?: string | null;
    readonly creator_in?: ReadonlyArray<string> | null;
    readonly creator_lt?: string | null;
    readonly creator_lte?: string | null;
    readonly creator_nbtwn?: ReadonlyArray<string> | null;
    readonly creator_nin?: ReadonlyArray<string> | null;
    readonly entityUuid?: string | null;
    readonly entityUuid_btwn?: ReadonlyArray<string> | null;
    readonly entityUuid_gt?: string | null;
    readonly entityUuid_gte?: string | null;
    readonly entityUuid_in?: ReadonlyArray<string> | null;
    readonly entityUuid_lt?: string | null;
    readonly entityUuid_lte?: string | null;
    readonly entityUuid_nbtwn?: ReadonlyArray<string> | null;
    readonly entityUuid_nin?: ReadonlyArray<string> | null;
    readonly OR?: ReadonlyArray<UserSubGroupWhereInput> | null;
    readonly userUuid?: string | null;
    readonly userUuid_btwn?: ReadonlyArray<string> | null;
    readonly userUuid_gt?: string | null;
    readonly userUuid_gte?: string | null;
    readonly userUuid_in?: ReadonlyArray<string> | null;
    readonly userUuid_lt?: string | null;
    readonly userUuid_lte?: string | null;
    readonly userUuid_nbtwn?: ReadonlyArray<string> | null;
    readonly userUuid_nin?: ReadonlyArray<string> | null;
    readonly uuid?: string | null;
    readonly uuid_btwn?: ReadonlyArray<string> | null;
    readonly uuid_gt?: string | null;
    readonly uuid_gte?: string | null;
    readonly uuid_in?: ReadonlyArray<string> | null;
    readonly uuid_lt?: string | null;
    readonly uuid_lte?: string | null;
    readonly uuid_nbtwn?: ReadonlyArray<string> | null;
    readonly uuid_nin?: ReadonlyArray<string> | null;
};
export type SubGroupDropdown_QueryVariables = {
    readonly where: UserSubGroupWhereInput;
};
export type SubGroupDropdown_QueryResponse = {
    readonly userSubGroupList: ReadonlyArray<{
        readonly subGroup: {
            readonly uuid: string;
            readonly name: string | null;
            readonly logoImageLocation: string | null;
        } | null;
    } | null> | null;
};
export type SubGroupDropdown_Query = {
    readonly response: SubGroupDropdown_QueryResponse;
    readonly variables: SubGroupDropdown_QueryVariables;
};



/*
query SubGroupDropdown_Query(
  $where: UserSubGroupWhereInput!
) {
  userSubGroupList(where: $where) {
    subGroup {
      uuid
      name
      logoImageLocation
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "UserSubGroupWhereInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logoImageLocation",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SubGroupDropdown_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userSubGroupList",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSubGroup",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "subGroup",
            "storageKey": null,
            "args": null,
            "concreteType": "SubGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SubGroupDropdown_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userSubGroupList",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSubGroup",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "subGroup",
            "storageKey": null,
            "args": null,
            "concreteType": "SubGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SubGroupDropdown_Query",
    "id": null,
    "text": "query SubGroupDropdown_Query(\n  $where: UserSubGroupWhereInput!\n) {\n  userSubGroupList(where: $where) {\n    subGroup {\n      uuid\n      name\n      logoImageLocation\n      id\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'd29b7fe6af41f014fdb22cbff103cf42';
export default node;
